export const MULTI_IMAGE_UPLOAD_TOKENS = {
  size: {
    mobileBreakpoint: 768,
    previewHeight: 190,
    embeddedPreviewHeight: 96,
    embeddedPreviewWidth: 112,
    gridMinWidth: 220,
    uploadMinHeight: 176,
    iconButton: 44,
  },
} as const;
